import { Module } from '@nestjs/common';
import { PrismaModule } from '../prisma/prisma.module';
import { ReportesRemisionController } from './reportes-remision.controller';
import { ReportesRemisionService } from './reportes-remision.service';

@Module({
  imports: [PrismaModule],
  controllers: [ReportesRemisionController],
  providers: [ReportesRemisionService],
  exports: [ReportesRemisionService],
})
export class ReportesRemisionModule {}
